module.exports = __webpack_public_path__ + "assets/img/bg2.1534f0df.gif";